<template>
  <div class="d-flex align-items-center justify-content-between w-100">
    <div id="hideinmobile" class="candash-modal-label d-flex">
      {{ title }}
      <span v-if="mandatory" class="asterik">&nbsp;*</span>
    </div>
    <!-- :class="
				$v.profile.phoneNumber.$error || invalidPhone
					? 'phonenumber-error'
					: 'phonenumber-input'
			" -->
    <div class="w-100 d-flex align-items-center position-relative pl-0">
      <div
        class="w-100 position-relative phone-inputField"
        :class="{ focused: isFocused || modelValue[modelKey] }"
      >
        <!--  -->
        <b-form-input
          type="tel"
          id="candidateMobile"
          ref="candidateMobile"
          placeholder=" "
          v-model.trim="modelValue[modelKey]"
          name="candidateMobile"
          :class="{ 'error': error, 'phone-input-locked': disabled }"
          :readonly="disabled"
          @focus="isFocused = true"
          @blur="isFocused = false"
          :disabled="disabled"
          @keydown.enter="$emit('enter-phone')"
          autocomplete="off"
          @keypress="numbersOnly"
          style="padding-right: 50px !important;"
        ></b-form-input>
        <label
          for="candidateMobile"
          :class="{
            left63px: dialCodeLength === 1,
            left80px: dialCodeLength === 3,
          }"
        >
          Phone Number
        </label>
        <span
          v-if="showEdit"
          class="phone-edit-action"
          @click="$emit('edit')"
        >
          Edit
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
export default {
  props: {
    mandatory: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object,
      required: true,
    },
    modelKey: {
      type: String,
      required: true,
    },
    countryCode: {
      type: String,
      default: "+91",
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocused: false,
      dialCodeLength: 2,
    };
  },
  mounted() {
    this.initializeNewTel();
  },
  // watch: {
  //   modelValue(newValue) {
  //     this.localValue = newValue;
  //   },
  // },
  methods: {
    numbersOnly(evt) {
      if (evt.target.nodeName === "INPUT") {
        const charCode = evt.key;
        if ((charCode < "0" || charCode > "9") && charCode !== ".") {
          evt.preventDefault();
        } else {
          const value = this.modelValue[this.modelKey];
          if (this.countryCode === "91" && value.length >= 11) {
            evt.preventDefault();
          }
        }
      }
    },
    initializeNewTel() {
      this.$nextTick(() => {
        const input = this.$refs.candidateMobile?.$el;

        if (!input) return;

        const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

        // On mobile, body has position:fixed (login-modal-open-mobile class) which
        // causes intl-tel-input to size the dropdown to the full viewport height.
        // Use #loginModal (the actual overlay div) as the container so positioning
        // is calculated relative to the visible panel, not the fixed body.
        const dropdownContainer = isTouchDevice
          ? (document.getElementById("loginModal") || document.body)
          : document.body;

        const iti = intlTelInput(input, {
          utilsScript:
            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.3/js/utils.js",
          showSelectedDialCode: true,
          initialCountry: "IN",
          countrySearch: true,
          dropdownContainer,
          formatOnDisplay: false,
        });

        const initialDialCode = iti.getSelectedCountryData().dialCode;
        this.dialCodeLength = initialDialCode.length;
        this.$emit("countrycode", initialDialCode);

        // Fix dropdown position on modal open (desktop b-modal)
        this.$root.$on("bv::modal::shown", () => {
          setTimeout(() => {
            iti.setCountry("IN");
          }, 100);
        });

        const flagContainer = input.parentElement.querySelector(".iti__flag-container");
        if (flagContainer) {
          flagContainer.addEventListener("click", () => {
            const root = isTouchDevice ? input.closest(".iti") || document : document;
            const searchField = root.querySelector(".iti__search-input");
            if (searchField) {
              searchField.value = "";
              searchField.dispatchEvent(new Event("input", { bubbles: true }));
              if (!isTouchDevice) {
                searchField.focus();
              }
            }
          });
        }

        // Validation logic
        input.addEventListener("countrychange", () => {
          const code = iti.getSelectedCountryData().dialCode;
          const value = (this.modelValue[this.modelKey] || "").replace(
            /\s+/g,
            ""
          );

          this.$emit("countrycode", code);
          let isInvalid = false;
          if (code !== "91" && value) {
            isInvalid = !iti.isValidNumber();
          } else if (code === "91") {
            isInvalid = !/^[6-9]\d{9}$/.test(value);
          }

          this.$emit("phonevalidation", isInvalid);
        });

        input.addEventListener("input", () => {
          const value = (this.modelValue[this.modelKey] || "").replace(
            /\s+/g,
            ""
          );
          const code = iti.getSelectedCountryData().dialCode;

          if (code !== "91" && value) {
            const isInvalid = !iti.isValidNumber();
            this.$emit("phonevalidation", isInvalid);
          }
        });
      });
    },
  },
};
</script>

<style>
.iti {
  width: 100%;
}
.iti--show-selected-dial-code .iti__selected-flag {
  background-color: #fff;
  /* border: 1px solid #d0d5dd; */
  border-right: 1px solid #d0d5dd;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
.no-placeholder::placeholder {
  color: transparent;
}
.phone-inputField {
  position: relative;
}

.phone-inputField .form-control {
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.36px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  opacity: 1;
  height: 40px;
}

.phone-inputField .form-control.error {
  border-color: #dc143c !important;
}
.phone-inputField label {
  position: absolute;
  padding-left: 8px;
  top: 8px;
  left: 72px;
  cursor: text;
  margin-left: 8px;
}
.phone-inputField input:focus + label,
.phone-inputField input:not(:placeholder-shown) + label {
  opacity: 1;
  transform: translateY(-21px) translateX(8px);
  color: #667085;
  background: #fff;
  width: auto;
  padding: 0 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
}
.phone-inputField input:focus {
  border: 1px solid #4a7eff !important;
  background-color: #fff !important;
  box-shadow: none !important;
  outline: none !important;
}
.phone-inputField input {
  width: 100%;
  padding-left: 10px;
}

.phone-inputField label,
.phone-inputField input {
  transition: all 0.3s !important;
  transition-timing-function: ease !important;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1) !important;
  opacity: 0.5;
}
.phone-inputField {
  position: relative;
}

.phone-inputField label {
  position: absolute;
  /* left: 70px; */
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s ease;
  color: #888;
  pointer-events: none;
}

.phone-inputField.focused label,
.phone-inputField input:focus + label,
.phone-inputField input:not(:placeholder-shown) + label {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #667085;
  background: #f7f9fc;
  width: auto;
  padding: 0 8px;
  margin: 0;
  position: absolute;
  opacity: 1 !important;
  top: -1px;
  left: 9px;
  z-index: 10;
}
.left63px {
  padding-left: 0px !important;
}
.left80px {
  padding-left: 15px !important;
}
.phone-inputField input::placeholder {
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  color: #64748b !important;
}
.phone-inputField label {
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  color: #64748b !important;
}
.phone-edit-action {
  position: absolute !important;
  right: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  color: #4a7eff !important;
  cursor: pointer !important;
  z-index: 12 !important;
}
.phone-edit-action:hover {
  text-decoration: underline !important;
}

/* Ensure the intl-tel-input dropdown floats above Bootstrap-Vue modals (z-index 1050)
   and their backdrops (z-index 1040) when appended to document.body */
/* Must exceed the mobile login overlay (z-index: 2000) and any b-modal backdrop.
   position:absolute is forced because some project CSS overrides iti's default. */
.iti__dropdown-content {
  z-index: 3000 !important;
  position: absolute !important;
}

@media (max-width: 1028px) {
  .iti__dropdown-content {
    width: calc(100vw - 48px) !important;
    min-width: unset !important;
  }
}

/* Ensure flag button stays clickable in mobile — b-overlay wrapper must not block it */
.iti__flag-container,
.iti__selected-flag {
  pointer-events: auto !important;
  cursor: pointer !important;
  z-index: 4 !important;
}

</style>
